import * as Styled from "./style";
import type { CustomRequired } from "~/@types/utility-types";
import type { PostPurchaseVideoByCashierUrlArgs } from "~/components/templates/common/purchase-modal/purchase-main-content";
import { PurchaseCard } from "~/components/templates/common/purchase-modal/purchase-main-content/purchase-card";
import type { G_FetchVideoContentQuery } from "~/lib/graphql";
import { G_ServicePlan, G_VideoSeasonType } from "~/lib/graphql";
import { useAuth } from "~/provider/auth";
import { formatMoneyJapaneseYen } from "~/util/format-money-japanese-yen";

let purchaseTitleName: string;

type PurchaseSaleProps = {
  seasonType: G_VideoSeasonType;
  purchaseData: CustomRequired<G_FetchVideoContentQuery["videoContent"]>["ppvProducts"];
  postPurchaseVideoByCashierUrl: (args: PostPurchaseVideoByCashierUrlArgs) => Promise<void>;
};

/** 購入できる販売方法（EST）を表示するコンポーネント */
export const PurchaseSale = (props: PurchaseSaleProps) => {
  const { seasonType, purchaseData, postPurchaseVideoByCashierUrl } = props;
  const { servicePlan } = useAuth();

  return (
    <div>
      <Styled.HeadingBold size="M">購入</Styled.HeadingBold>

      {purchaseData?.map((item) => {
        const {
          id,
          episodeTitle,
          episodeNumberName,
          saleUnitName,
          isPurchased,
          isBundleParent,
          price: { price, salePrice, isLimitedPremium },
        } = item;

        if ([G_VideoSeasonType.Legacy, G_VideoSeasonType.SingleEpisode].includes(seasonType)) {
          purchaseTitleName = saleUnitName;
        }

        if ([G_VideoSeasonType.Stage].includes(seasonType)) {
          purchaseTitleName = episodeTitle;
        }

        if ([G_VideoSeasonType.MultiEpisodes].includes(seasonType)) {
          if (isBundleParent) {
            purchaseTitleName = `${saleUnitName} ${episodeTitle}`;
          } else {
            if (episodeNumberName !== null) {
              if (episodeNumberName === episodeTitle) {
                purchaseTitleName = `${saleUnitName} ${episodeTitle}`;
              } else {
                purchaseTitleName = `${saleUnitName} ${episodeNumberName} ${episodeTitle}`;
              }
            } else {
              purchaseTitleName = `${saleUnitName} ${episodeTitle}`;
            }
          }
        }

        /** 舞台の時だけバンドルかどうかを判定してバンドル作品だった場合は視聴期限を表示しない */
        const description = seasonType === G_VideoSeasonType.Stage && isBundleParent ? "" : "視聴期限：無期限";

        const isShowSalePrice = (() => {
          if (salePrice === price) return false;
          if (isLimitedPremium) {
            return servicePlan === G_ServicePlan.Premium;
          }
          return true;
        })();

        // 販売価格 と 定価 が同じ数値の場合は、割引前の価格を表示しないこと
        const buttonStrikeMainText = isShowSalePrice ? formatMoneyJapaneseYen(price) : "";

        const buttonMainText = formatMoneyJapaneseYen(isShowSalePrice ? salePrice : price);

        return (
          <PurchaseCard
            key={id}
            title={purchaseTitleName}
            description={description}
            isPurchased={isPurchased}
            buttonName="forBuy"
            buttonStrikeMainText={buttonStrikeMainText}
            buttonMainText={buttonMainText}
            isLimitedPremium={isLimitedPremium}
            onPurchasedButtonClicked={() =>
              postPurchaseVideoByCashierUrl({
                productId: item.id,
                productName: item.saleUnitName,
                trackingSendPrice: item.price.salePrice,
              })
            }
          />
        );
      })}
    </div>
  );
};
